import { formatTime as formatBaseTime } from '@chatwoot/utils';
import { getDateLocale } from './localizedDate.js';

// Keep the upstream duration calculation; localize only the displayed units.
export const formatTime = (...args) => {
  const formatted = formatBaseTime(...args);
  if (getDateLocale().code !== 'th') return formatted;
  const units = {
    Sec: 'วินาที',
    Min: 'นาที',
    Hr: 'ชม.',
    Day: 'วัน',
    Days: 'วัน',
    Yr: 'ปี',
    Month: 'เดือน',
  };
  return formatted.replace(
    /\b(Sec|Min|Hr|Days?|Yr|Month)\b/g,
    unit => units[unit]
  );
};
